import { cn } from '#app/utils/misc.tsx'

/**
 * Static styled mono code block. No parsing, no JS.
 * Used to tease the grammar on the public landing.
 */
export function NotationPreview({
	children,
	className,
}: {
	children: React.ReactNode
	className?: string
}) {
	return (
		<pre
			className={cn(
				'inline-block rounded-r-sm border-l-2 border-ember bg-ink-soft px-4 py-3 font-mono-display text-mono-label text-ember',
				className,
			)}
		>
			{children}
		</pre>
	)
}
